import { useEffect } from 'react';

const BASE_TITLE = 'Novster AI';

export function useTitle() {
  const setTitle = (pageTitle?: string) => {
    document.title = pageTitle ? `${BASE_TITLE} - ${pageTitle}` : BASE_TITLE;
  };

  useEffect(() => {
    return () => {
      document.title = BASE_TITLE;
    };
  }, []);

  return { setTitle };
};